import React from "react";
import SimplePage from "./SimplePage";

const Privacy: React.FC = () => {
  return (
    <SimplePage title="Privacy Policy" lastUpdated="June 2026">
      <p>
        This Privacy Policy explains how Tally ("we," "us," "our") collects,
        uses, and protects information when you use our platform — whether
        as a merchant or a customer.
      </p>

      <h2>Information we collect</h2>
      <p>For merchants, we collect:</p>
      <ul>
        <li>Shop name, owner name, phone number, and business location</li>
        <li>Sales records you enter, including amounts and timestamps</li>
        <li>Staff account information you create</li>
      </ul>
      <p>For customers, we collect:</p>
      <ul>
        <li>Name and phone number provided when redeeming a slip code</li>
        <li>Purchase and visit history at shops using Tally</li>
        <li>Reward progress and redemption history</li>
      </ul>

      <h2>How we use your information</h2>
      <p>We use the information collected to:</p>
      <ul>
        <li>Record and track sales, visits, and loyalty progress</li>
        <li>Alert merchants when a customer's visit pattern changes</li>
        <li>Enable merchants to send messages to their own customers</li>
        <li>Generate AI-powered insights and message suggestions</li>
        <li>Improve and maintain the Tally platform</li>
      </ul>

      <h2>Data ownership</h2>
      <p>
        Your customer data belongs to you. If you stop using Tally, your
        data remains in your account and is never sold or shared with third
        parties for advertising purposes.
      </p>

      <h2>Data sharing</h2>
      <p>
        We do not sell your personal information. We may share limited data
        with trusted service providers who help us operate Tally (such as
        our database and hosting providers), strictly to deliver the
        service to you.
      </p>

      <h2>Data security</h2>
      <p>
        We use industry-standard practices to protect your information,
        including encrypted passwords and secure data storage. While no
        system is completely immune to risk, we take reasonable steps to
        keep your data safe.
      </p>

      <h2>Your rights</h2>
      <p>
        You can request access to, correction of, or deletion of your
        personal data at any time by contacting us at{" "}
        <a href="mailto:hello@gettally.store">hello@gettally.store</a>.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Material
        changes will be communicated through the platform.
      </p>

      <h2>Contact us</h2>
      <p>
        Questions about this policy? Reach us at{" "}
        <a href="mailto:hello@gettally.store">hello@gettally.store</a>.
      </p>
    </SimplePage>
  );
};

export default Privacy;